import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import visibleImg from "../../../../../picture/Visible.png";
import { useGlobalContext } from "../../../../../Context/Context";
import deleteImg from "../../../../../picture/delete.png";
import resetImg from "../../../../../picture/timer-language.png";
import ConfirmationModal from "./ConfirmationModal";
import axios from "axios";

const styles = {
  cell: { padding: "5px", textAlign: "center", fontSize: "14px" },
  button: { padding: "10px 30px" }
};

function LzoDetaljiModal({ item, baseUrl, onClose }) {
  if (!item) return null;
  const slikaUrl = item.slika_path ? `${baseUrl.replace('/api', '')}/${item.slika_path}` : null;

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)", display: "flex",
      justifyContent: "center", alignItems: "center", zIndex: 1000
    }}>
      <div style={{ backgroundColor: "white", borderRadius: "10px", padding: "30px", width: "500px", maxHeight: "80vh", overflowY: "auto" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "15px" }}>{item.naziv}</div>
        {slikaUrl ? (
          <img src={slikaUrl} alt={item.naziv}
            style={{ width: "100%", maxHeight: "220px", objectFit: "contain", marginBottom: "15px", border: "1px solid #eee" }} />
        ) : (
          <div style={{ width: "100%", height: "120px", backgroundColor: "#f5f5f5", display: "flex", alignItems: "center",
            justifyContent: "center", marginBottom: "15px", fontSize: "13px", color: "#aaa" }}>
            Nema slike
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", fontSize: "14px" }}>
          <div><span style={{ fontWeight: "bold" }}>Kategorija: </span>{item.kategorija}</div>
          <div><span style={{ fontWeight: "bold" }}>Standard: </span>{item.standard}</div>
          <div><span style={{ fontWeight: "bold" }}>Namena: </span>{item.namena}</div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
          <div onClick={onClose}><Button activation={true} style={styles.button}>ZATVORI</Button></div>
        </div>
      </div>
    </div>
  );
}

function LZOTabela() {
  const [allData, setAllData] = useState([]);
  const [arhiviraniData, setArhiviraniData] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [idDelete, setIdDelete] = useState("");
  const [detaljiItem, setDetaljiItem] = useState(null);

  const { setFolderDokumentCurrentState, selectedMainEntity, baseUrl } = useGlobalContext();

  const fetchData = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/lzo_firma/read.php`, {
        company_id: selectedMainEntity.company_id
      });
      if (data.status === 200) {
        setAllData(data.data.filter(d => d.is_arhivirano == 0));
        setArhiviraniData(data.data.filter(d => d.is_arhivirano == 1));
      }
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchData();
  }, [selectedMainEntity]);

  const handleCheckRow = (item) => {
    if (checkedRows.find(r => r.id === item.id)) setCheckedRows(checkedRows.filter(r => r.id !== item.id));
    else setCheckedRows([...checkedRows, item]);
  };

  const handleCheckAll = () => {
    setCheckedRows(isCheckedAll ? [] : allData);
    setIsCheckedAll(prev => !prev);
  };

  const handleArchive = async () => {
    try {
      await Promise.all(checkedRows.map(row =>
        axios.post(`${baseUrl}/lzo_firma/archive.php`, { id: row.id })
      ));
      setCheckedRows([]);
      setIsCheckedAll(false);
      fetchData();
    } catch (e) { console.error(e); }
  };

  const handleRestore = async (item) => {
    try {
      await axios.post(`${baseUrl}/lzo_firma/restore.php`, { id: item.id });
      fetchData();
    } catch (e) { console.error(e); }
  };

  const handleConfirmDelete = async () => {
    try {
      await axios.post(`${baseUrl}/lzo_firma/delete.php`, { id: idDelete });
      setIdDelete("");
      fetchData();
    } catch (e) { console.error(e); }
  };

  return (
    <div style={{ padding: "20px", fontSize: "14px", height: "100%", width: "100%", backgroundColor: "#F9F9F9" }}>
      <style>{`#lzo-tabela td, #lzo-tabela th { font-size: 14px !important; }`}</style>
      <div style={{ overflowY: "auto", height: "calc(100% - 50px)" }} id="lzo-tabela">
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={styles.cell}>
                <input type="checkbox" checked={isCheckedAll} onChange={handleCheckAll} style={{ width: "25px" }} />
              </th>
              <th style={styles.cell}>Rb.</th>
              <th style={{ ...styles.cell, width: "45%" }}>LIČNA ZAŠTITNA OPREMA</th>
              <th style={{ ...styles.cell, width: "10%" }}>STANDARD</th>
              <th style={styles.cell}>IZD</th>
              <th style={styles.cell}>MAG</th>
              <th style={styles.cell}>SUM</th>
              <th style={styles.cell}>OTP</th>
              <th style={styles.cell}></th>
            </tr>
          </thead>
          <tbody>
            {allData.map((item, i) => (
              <tr key={item.id}>
                <td style={styles.cell}>
                  <input type="checkbox" checked={!!checkedRows.find(r => r.id === item.id)}
                    onChange={() => handleCheckRow(item)} style={{ width: "25px" }} />
                </td>
                <td style={styles.cell}>{i + 1}.</td>
                <td style={styles.cell}>{item.naziv}</td>
                <td style={styles.cell}>{item.standard}</td>
                <td style={styles.cell}>{item.izd}</td>
                <td style={styles.cell}>{item.mag}</td>
                <td style={styles.cell}>{parseInt(item.izd) + parseInt(item.mag)}</td>
                <td style={styles.cell}>{item.otp}</td>
                <td style={{ ...styles.cell, cursor: "pointer" }} onClick={() => setDetaljiItem(item)}>
                  <img src={visibleImg} style={{ width: "25px" }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* <table style={{ width: "100%", marginTop: "30px" }}>
          <thead>
            <tr>
              <th style={styles.cell}>Rb.</th>
              <th style={{ ...styles.cell, width: "45%" }}>ARHIVIRANA DOKUMENTA</th>
              <th style={{ ...styles.cell, width: "10%" }}>STANDARD</th>
              <th style={styles.cell}>IZD</th>
              <th style={styles.cell}>MAG</th>
              <th style={styles.cell}>SUM</th>
              <th style={styles.cell}>OTP</th>
              <th style={styles.cell}></th>
              <th style={styles.cell}></th>
              <th style={styles.cell}></th>
            </tr>
          </thead>
          <tbody>
            {arhiviraniData.map((item, i) => (
              <tr key={item.id}>
                <td style={styles.cell}>{i + 1}.</td>
                <td style={styles.cell}>{item.naziv}</td>
                <td style={styles.cell}>{item.standard}</td>
                <td style={styles.cell}>{item.izd}</td>
                <td style={styles.cell}>{item.mag}</td>
                <td style={styles.cell}>{parseInt(item.izd) + parseInt(item.mag)}</td>
                <td style={styles.cell}>{item.otp}</td>
                <td style={{ ...styles.cell, cursor: "pointer" }} onClick={() => setDetaljiItem(item)}>
                  <img src={visibleImg} style={{ width: "25px" }} />
                </td>
                <td style={{ ...styles.cell, cursor: "pointer" }} onClick={() => setIdDelete(item.id)}>
                  <img src={deleteImg} style={{ width: "25px" }} />
                </td>
                <td style={{ ...styles.cell, cursor: "pointer" }} onClick={() => handleRestore(item)}>
                  <img src={resetImg} style={{ width: "25px" }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}
      </div>

      <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between", gap: "20px" }}>
        <div style={{ display: "flex", gap: "10px" }}>
          {checkedRows.length > 0 ? (
            <div onClick={handleArchive}><Button activation={true} style={styles.button}>ARHIVIRAJ</Button></div>
          ) : (
            <>
              <div><Button activation={true} style={styles.button}>ŠTAMPAJ</Button></div>
              <div><Button activation={true} style={styles.button}>POŠALJI</Button></div>
            </>
          )}
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <div onClick={() => setFolderDokumentCurrentState("DODAVANJE_POSTOJECI")}>
            <Button activation={true} style={styles.button}>DODAJ</Button>
          </div>
          <div onClick={() => setFolderDokumentCurrentState("AZURIRANJE")}>
            <Button activation={true} style={styles.button}>AŽURIRAJ</Button>
          </div>
        </div>
      </div>

      {detaljiItem && (
        <LzoDetaljiModal item={detaljiItem} baseUrl={baseUrl} onClose={() => setDetaljiItem(null)} />
      )}

      {idDelete && (
        <ConfirmationModal
          handleConfirm={handleConfirmDelete}
          text="Da li ste sigurni da želite da obrišete LZO?"
          handleCancel={() => setIdDelete("")}
        />
      )}
    </div>
  );
}

export default LZOTabela;